import { render, staticRenderFns } from "./AddDB.vue?vue&type=template&id=6c0713cf&scoped=true&"
import script from "./AddDB.vue?vue&type=script&lang=js&"
export * from "./AddDB.vue?vue&type=script&lang=js&"
import style0 from "./AddDB.vue?vue&type=style&index=0&id=6c0713cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0713cf",
  null
  
)

export default component.exports